import Typography from '@mui/material/Typography';
import { useAppSelector } from "../../../app/hooks";
import { ProgramAreas } from '../../../app/models';
import { FaqType } from "../../../app/models";
import { selectBlackbaudRequestData } from '../../Common/stateSlices/bbgDataSlice';
  
function supportStaff(id:ProgramAreas | string): {name: string, email: string} {
    const staff = {
        [ProgramAreas.CFWB]: { name: "Kate Gaskin", email: "kgaskin@tde.org"},
        [ProgramAreas.HC]: { name: "Julie Hale", email: "jhale@tde.org"},
        [ProgramAreas.HE]: { name: "Ashleigh Allessio", email: "aallessio@tde.org"},
        [ProgramAreas.SI]: { name: "Charisma Hibbler", email: "chibbler@tde.org"},
        [ProgramAreas.RC]: { name: "Jackie Lademann", email: "jlademann@tde.org"},
        [ProgramAreas.ADMIN]: { name: "Allen Lane", email: "alane@tde.org"}
    }

    return staff?.[id] || { name: "Support Staff", email: ""}
}

export const AdminContacts = (props: {faqType: FaqType}) => {
    const {faqType} = props; 
    const bbgData = useAppSelector( selectBlackbaudRequestData)
    const {programArea} = bbgData
    const {name, email} = supportStaff(programArea);
    const hrefTarget = `mailto:${email}`

    if (email === "") {
        return (
            <>
                <Typography variant="h4" sx={{color: 'black', fontSize: '2.5ch'}}>
                    Please contact your program officer for asssistance
                </Typography>
            </>
        )
    }

    return (            
        <>
            <Typography variant="h4" sx={{color: 'black', fontSize: '2.5ch'}}>
                {name}
            </Typography>
            <Typography sx={{ marginLeft: "2ch" }}>
                Email: <a href={hrefTarget} target="_blank">{email}</a>
            </Typography>
        </>
        )

}